import React, { useEffect, useState } from "react";
import Banner from "./sections/PageBanner";
import PageHeader from "./sections/PageHeader";
import Footer from "./sections/PageFooter";
import axios from "../../utils/axios";
import { Button, Checkbox, Container, Group, Table } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import Cases from "../Cases";
import {
    Document,
    Packer,
    Paragraph,
    TextRun
} from "docx";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";

const stripHtml = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText;
};

const handleDownloadPDF = (title: string, content: string) => {
    const container = document.createElement("div");
    container.innerHTML = `
        <div style="font-family: 'Arial', sans-serif; padding: 20px; font-size: 14px;">
            <h1 style="font-size: 20px; font-weight: bold;">${title}</h1>
            <div>${content}</div>
        </div>
    `;

    html2pdf()
        .set({
            margin: 0.5,
            filename: `${title}.pdf`,
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        })
        .from(container)
        .save();
};


const handleDownload = async (caseTitle: string, caseContent: string) => {
    const plainText = stripHtml(caseContent);

    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: caseTitle,
                                bold: true,
                                size: 28
                            }),
                        ],
                    }),
                    new Paragraph({
                        text: plainText,
                        spacing: {
                            before: 200,
                        }
                    }),
                ],
            },
        ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${caseTitle}.docx`);
};

const Precedents = () => {
    const [cases, setCases] = useState([]);

    const [loading, setLoading] = useState(false);

    const { height, width } = useViewportSize();

    useEffect(() => {
        setLoading(true);
        axios.get("/precedents/all").then(function(res){
            if(res.status === 200){
                setCases(res.data.data);
                setLoading(false);
            }
        }).catch(function(err){
            console.log(err);
            setLoading(false);
        })
    }, []);
  return (
    loading ? (<Cases />) : (
                    <div>
                    <Container mt={30} mb={30} size={width * 0.95}>
                    <div style={{ overflowX: "auto", overflowY: "auto"}} className='overflow-x-auto'>
                    <Table withBorder withColumnBorders striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>
                                <Checkbox />
                            </th>
                            <th style={{ whiteSpace: 'nowrap' }}>Title</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Summary</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.length === 0 ? (
                                <tr>
                                    <td colSpan={5} style={{textAlign: "center"}}>No case precedents found</td>
                                  
                                </tr>
                            ) : (
                                cases.map((itm: any, idx: number) => {
                                    return (
                                        <tr key={idx}>
                                            <td>
                                                {idx + 1}
                                            </td>
                                            <td>
                                                <Checkbox />
                                            </td>
                                            <td>
                                                {itm?.title}
                                            </td>
                                            <td>
                                                <div style={{ height: height * 0.4, overflowY: "auto", width: width * 0.4 }}>
                                                    <div dangerouslySetInnerHTML={{ __html: itm.content }} />
                                                </div>
                                            </td>
                                            <td>
                                                <Group noWrap>
                                                    <Button size='xs' onClick={() => handleDownloadPDF(itm.title, itm.content)}>Download</Button>
                                                </Group>
                                            </td>
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </Table>
                    </div>
                    </Container>
                    </div>
    )
  );
};

function PrecedentsPage(){
    return (
        <>
        <Banner />
        <PageHeader />
        <Precedents />
        <Footer />
        </>
    )
}

export default PrecedentsPage;
